export const CANTRATE_ID = 123456789;
export const CANTRATE_TEXT = 'Не могу оценить';

export const KANO_ANSWERS = [
    'Мне это очень понравится',
    'Это меня устроит',
    'Нейтрально',
    'Смирюсь / терпимо',
    'Мне это не понравится',
];

// Тексты оценок Кано можно менять в конструкторе (params.kanoAnswers).
// Пустое значение или отсутствующий текст откатывается к дефолтному.
export const getKanoAnswers = (customAnswers?: Array<string>): Array<string> =>
    KANO_ANSWERS.map((defaultAnswer, index) => {
        const customAnswer = customAnswers?.[index];
        return typeof customAnswer === 'string' && customAnswer.trim() ? customAnswer : defaultAnswer;
    });
